import React, { FC } from 'react';
import Pagination from '../../shared/common/Pagination';
import { Button, ButtonSize, ButtonTheme } from '../../shared/common/Button';
import RoutingUtils from '../../shared/utils/utils-routing';
import { useTranslation } from 'react-i18next';
import { COLLECTION_NAVIGATION_V2, useFeature } from '../../shared/utils/togglz';

type Props = {
    subscriptionCount?: number;
    page: number;
    pageSize: number;
    onPageChange: (page: number) => void;
};

export const ManageSubscriptionsHeader: FC<Props> = ({ onPageChange, page, pageSize, subscriptionCount }) => {
    const { t } = useTranslation();
    const isCollectionNavigationV2Enabled = useFeature(COLLECTION_NAVIGATION_V2);

    return (
        <>
            <div className="action-bar">
                <h4>{t('shop.subscriptions.subscriptionManagement')}</h4>
            </div>
            <div className="filter-bar">
                <div className="layout-column-33 fl-left">
                    <div className="total-products-label">
                        {subscriptionCount ? (
                            <>
                                {t('shop.subscriptions.subscriptionCount', {
                                    count: subscriptionCount
                                })}
                            </>
                        ) : null}
                    </div>
                </div>
                <div className="layout-column-33 fl-left">
                    <Pagination
                        pageSize={pageSize}
                        currentPage={page}
                        onPageChange={onPageChange}
                        totalItems={subscriptionCount}
                    />
                </div>
                <div className="right layout-column-33">
                    <Button
                        text={t('shop.subscriptions.manageRenewals')}
                        theme={ButtonTheme.POSITIVE_INVERT}
                        size={ButtonSize.MEDIUM}
                        icon="shopping_cart"
                        onClick={() =>
                            RoutingUtils.pushUrl(
                                isCollectionNavigationV2Enabled
                                    ? '/collectionmgmt/subscriptions/renewals'
                                    : '/assistant/subscriptions/renewals'
                            )
                        }
                    />
                </div>
            </div>
        </>
    );
};
